"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleError = handleError;
const errors_1 = require("@invivodf/errors");
function isAxiosError(error) {
    return error.isAxiosError ?? false;
}
// Helper function to check if data has the structure of an error response
function isErrorData(value) {
    return value && typeof value.key === 'string' && typeof value.message === 'string';
}
/**
 * Helper method used to simplify axios error handling
 * @param error
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function handleError(error) {
    if (!isAxiosError(error)) {
        throw new errors_1.DomainError('Unhandled error', 'technical.unknown');
    }
    if (!error.response) {
        throw new errors_1.DomainError('No Response', 'technical.unknown');
    }
    const data = error.response.data;
    if (isErrorData(data)) {
        throw new errors_1.DomainError(data.message, data.key);
    }
    if (error.response.status === 401) {
        throw new errors_1.DomainError('Client not authenticated', 'technical.unauthorized');
    }
    if (error.response.status === 403) {
        throw new errors_1.ForbiddenError('Client is missing permissions');
    }
    throw new errors_1.DomainError('Unsupported error', 'technical.unknown');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2luZnJhL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQWlCQSxrQ0FrQkM7QUFuQ0QsNkNBQThEO0FBRzlELFNBQVMsWUFBWSxDQUFDLEtBQWM7SUFDbEMsT0FBUSxLQUE2QixDQUFDLFlBQVksSUFBSSxLQUFLLENBQUE7QUFDN0QsQ0FBQztBQUVELDBFQUEwRTtBQUMxRSxTQUFTLFdBQVcsQ0FBQyxLQUFVO0lBQzdCLE9BQU8sS0FBSyxJQUFJLE9BQU8sS0FBSyxDQUFDLEdBQUcsS0FBSyxRQUFRLElBQUksT0FBTyxLQUFLLENBQUMsT0FBTyxLQUFLLFFBQVEsQ0FBQTtBQUNwRixDQUFDO0FBRUQ7OztHQUdHO0FBQ0gsaUhBQWlIO0FBQ2pILFNBQWdCLFdBQVcsQ0FBQyxLQUFVO0lBQ3BDLElBQUcsQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQztRQUN4QixNQUFNLElBQUksb0JBQVcsQ0FBQyxpQkFBaUIsRUFBRSxtQkFBbUIsQ0FBQyxDQUFBO0lBQy9ELENBQUM7SUFDRCxJQUFHLENBQUMsS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDO1FBQ25CLE1BQU0sSUFBSSxvQkFBVyxDQUFDLGFBQWEsRUFBRSxtQkFBbUIsQ0FBQyxDQUFBO0lBQzNELENBQUM7SUFDRCxNQUFNLElBQUksR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQTtJQUNoQyxJQUFHLFdBQVcsQ0FBQyxJQUFJLENBQUMsRUFBQyxDQUFDO1FBQ3BCLE1BQU0sSUFBSSxvQkFBVyxDQUFFLElBQVksQ0FBQyxPQUFPLEVBQUcsSUFBWSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ2pFLENBQUM7SUFDRCxJQUFJLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRSxDQUFDO1FBQ2xDLE1BQU0sSUFBSSxvQkFBVyxDQUFDLDBCQUEwQixFQUFFLHdCQUF3QixDQUFDLENBQUE7SUFDN0UsQ0FBQztJQUNELElBQUksS0FBSyxDQUFDLFFBQVEsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFLENBQUM7UUFDbEMsTUFBTSxJQUFJLHVCQUFjLENBQUMsK0JBQStCLENBQUMsQ0FBQTtJQUMzRCxDQUFDO0lBQ0QsTUFBTSxJQUFJLG9CQUFXLENBQUMsbUJBQW1CLEVBQUUsbUJBQW1CLENBQUMsQ0FBQTtBQUNqRSxDQUFDIn0=